import { IPage, ISearchPage } from '@/types/AppTypes'
import { getBaseCiRequestUrl, getToken } from '@/utils/constants'
import { httpRequest } from '@/utils/HttpRequest'

/**
 * 分页条件 搜索参数 `{}`
 *
 * FranchiseeSearchItem
 */
export interface IFranchiseeSearchItem {
    /**
     * 办公地址
     */
    address?: null | string;
    /**
     * 证明
     */
    attestation?: null | string;
    /**
     * 开户银行
     */
    bank?: null | string;
    /**
     * 账号
     */
    bankAcct?: null | string;
    /**
     * 企业电话
     */
    bankPhone?: null | string;
    /**
     * 业务经理
     */
    businessManager?: null | string;
    /**
     * 经营性质
     */
    businessNature?: null | string;
    /**
     * 经营范围
     */
    businessScope?: null | string;
    /**
     * 编码
     */
    code?: null | string;
    /**
     * 公司规模
     */
    companySize?: null | string;
    /**
     * 联系人
     */
    contact?: null | string;
    /**
     * 合作等级
     */
    cooperationLevel?: null | string;
    /**
     * 法人
     */
    corporation?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标志
     */
    deleteFlag?: number | null;
    /**
     * 加盟设备
     */
    franchiseEquipment?: null | string;
    /**
     * 加盟类型
     */
    franchiseType?: null | string;
    id?: null | string;
    /**
     * 发票抬头
     */
    invoiceTitle?: null | string;
    /**
     * 是否认证
     */
    isCertified?: null | string;
    /**
     * 纬度
     */
    latitude?: null | string;
    /**
     * 纳税人识别号
     */
    licenseNo?: null | string;
    /**
     * 经度
     */
    longitude?: null | string;
    /**
     * 主要配置
     */
    mainConfig?: null | string;
    /**
     * 名称
     */
    name?: null | string;
    /**
     * 加盟商类型（个人 、企业）
     */
    note?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 备注
     */
    orgType?: null | string;
    /**
     * 人员储备
     */
    personnelReserves?: null | string;
    /**
     * 联系电话
     */
    phone?: null | string;
    /**
     * 邮寄地址
     */
    postAddress?: null | string;
    /**
     * 资质
     */
    qualification?: null | string;
    /**
     * 加盟商状态
     */
    status?: string[] | null;
    /**
     * 链路id
     */
    traceId?: null | string;
    /**
     * 最后更新时间
     */
    updateTime?: null | string;
    /**
     * 最后修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}

/**
 * 返回数据
 *
 * PageResult«FranchiseePageResult»
 */
export interface PageResultFranchiseePageResult {
    /**
     * 当前页面最后一个元素在数据库中的行号
     */
    endRow?: number | null;
    /**
     * 是否有下一页
     */
    hasNextPage?: boolean | null;
    /**
     * 是否有前一页
     */
    hasPreviousPage?: boolean | null;
    /**
     * 是否为第一页
     */
    isFirstPage?: boolean | null;
    /**
     * 是否为最后一页
     */
    isLastPage?: boolean | null;
    /**
     * 结果集
     */
    list?: FranchiseePageResult[] | null;
    /**
     * 导航条上的第一页
     */
    navigateFirstPage?: number | null;
    /**
     * 导航条上的最后一页
     */
    navigateLastPage?: number | null;
    /**
     * 所有导航页号
     */
    navigatepageNums?: number[] | null;
    /**
     * 导航页码数
     */
    navigatePages?: number | null;
    /**
     * 下一页
     */
    nextPage?: number | null;
    /**
     * 当前页
     */
    pageNum?: number | null;
    /**
     * 总页数
     */
    pages?: number | null;
    /**
     * 每页的数量
     */
    pageSize?: number | null;
    /**
     * 前一页
     */
    prePage?: number | null;
    /**
     * 当前页的数量
     */
    size?: number | null;
    /**
     * 当前页面第一个元素在数据库中的行号
     */
    startRow?: number | null;
    /**
     * 总记录数
     */
    total?: number | null;
    [property: string]: any;
}

/**
 * 加盟商信息表
 *
 * FranchiseePageResult
 */
export interface FranchiseePageResult {
    /**
     * 办公地址
     */
    address?: null | string;
    /**
     * 证明
     */
    attestation?: null | string;
    authenticationList?: Authentication[] | null;
    /**
     * 开户银行
     */
    bank?: null | string;
    /**
     * 账号
     */
    bankAcct?: null | string;
    /**
     * 企业电话
     */
    bankPhone?: null | string;
    /**
     * 业务经理
     */
    businessManager?: null | string;
    /**
     * 经营性质
     */
    businessNature?: null | string;
    /**
     * 经营范围
     */
    businessScope?: null | string;
    /**
     * 编码
     */
    code?: null | string;
    /**
     * 公司规模
     */
    companySize?: null | string;
    /**
     * 联系人
     */
    contact?: null | string;
    cooperationAgreementList?: CooperationAgreement[] | null;
    /**
     * 合作等级
     */
    cooperationLevel?: null | string;
    /**
     * 法人
     */
    corporation?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标记 `0 正常 1 已删除`
     */
    deleteFlag?: number | null;
    /**
     * 图片名称
     */
    fileName?: null | string;
    followUpList?: FollowUp[] | null;
    /**
     * 加盟设备
     */
    franchiseEquipment?: null | string;
    /**
     * 加盟类型
     */
    franchiseType?: null | string;
    /**
     * id
     */
    id: string;
    /**
     * 身份证件号
     */
    idNum?: null | string;
    /**
     * 发票抬头
     */
    invoiceTitle?: null | string;
    /**
     * 是否认证
     */
    isCertified?: null | string;
    /**
     * 纬度
     */
    latitude?: null | number;
    /**
     * 纳税人识别号
     */
    licenseNo?: null | number;
    /**
     * 经度
     */
    longitude?: null | number;
    /**
     * 主要配置
     */
    mainConfig?: null | string;
    /**
     * md5
     */
    md5?: null | string;
    /**
     * 名称
     */
    name?: null | string;
    /**
     * 加盟商类型（个人 、企业）
     */
    note?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 备注
     */
    orgType?: null | string;
    /**
     * 人员储备
     */
    personnelReserves?: null | string;
    /**
     * 联系电话
     */
    phone?: null | string;
    /**
     * 邮寄地址
     */
    postAddress?: null | string;
    /**
     * 资质
     */
    qualification?: null | string;
    /**
     * 加盟商状态
     */
    status?: null | string;
    traceId?: null | string;
    /**
     * 修改时间
     */
    updateTime?: null | string;
    /**
     * 修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}

/**
 * 认证信息表
 *
 * Authentication
 */
export interface Authentication {
    /**
     * code
     */
    code?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标记 `0 正常 1 已删除`
     */
    deleteFlag?: number | null;
    /**
     * 加盟商编号
     */
    franchiseeCode?: null | string;
    /**
     * id
     */
    id?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 认证结果
     */
    result?: null | string;
    traceId?: null | string;
    /**
     * 例如二维码认证、手机号码认证
     */
    type?: null | string;
    /**
     * 修改时间
     */
    updateTime?: null | string;
    /**
     * 修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}

/**
 * 合同信息表
 *
 * CooperationAgreement
 */
export interface CooperationAgreement {
    /**
     * code
     */
    code?: null | string;
    /**
     * 联系人
     */
    contact?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标记 `0 正常 1 已删除`
     */
    deleteFlag?: number | null;
    /**
     * 电子签名
     */
    electronicSignature?: null | string;
    /**
     * 名称
     */
    endTime?: null | string;
    /**
     * 图片名称
     */
    fileName?: null | string;
    /**
     * 加盟商编号
     */
    franchiseeCode?: null | string;
    /**
     * id
     */
    id?: null | string;
    /**
     * md5
     */
    md5?: null | string;
    /**
     * 签约模式
     */
    mode?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 联系电话
     */
    phone?: null | string;
    /**
     * 加盟商编号
     */
    startTime?: null | string;
    /**
     * 合同状态 有效, 已过期,已终止
     */
    status?: null | string;
    /**
     * 名称
     */
    terms?: null | string;
    traceId?: null | string;
    /**
     * 修改时间
     */
    updateTime?: null | string;
    /**
     * 修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}

/**
 * 加盟商跟进表
 *
 * FollowUp
 */
export interface FollowUp {
    /**
     * code
     */
    code?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标记 `0 正常 1 已删除`
     */
    deleteFlag?: number | null;
    /**
     * 反馈意见
     */
    feedback?: null | string;
    /**
     * 跟进内容
     */
    followUpContent?: null | string;
    /**
     * 跟进方式
     */
    followUpMethod?: null | string;
    /**
     * 加盟商编号
     */
    franchiseeCode?: null | string;
    /**
     * id
     */
    id?: null | string;
    /**
     * 意向程度
     */
    intentionLevel?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 合同状态 有效, 已过期,已终止
     */
    status?: null | string;
    traceId?: null | string;
    /**
     * 修改时间
     */
    updateTime?: null | string;
    /**
     * 修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}

//搜索条件
export interface IMaintenanceArchivesSearchFields {
    name?: string
    [key: string]: any
}

export interface IMaintenanceArchivesSearch extends IMaintenanceArchivesSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IMaintenanceArchivesSearchFields, ISearchPage { }

//新增
export interface IFranchiseePageResultInsert extends FranchiseePageResult { }

//编辑
export interface IFranchiseePageResultUpdate extends IFranchiseePageResultInsert {
    id: string
}

export interface IGroupByNameBrandModelDetail {
    name: string
    code: string
    vehicleBrandName?: string
    vehicleModelName?: string
    [key: string]: any
}

/**
 * 参数
 *
 * CooperationAgreementInsertOrUpdateParams
 */
export interface ICooperationAgreementInsertOrUpdateParams {
    /**
     * code
     */
    code?: null | string;
    /**
     * 联系人
     */
    contact?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标志
     */
    deleteFlag?: number | null;
    /**
     * 电子签名
     */
    electronicSignature?: null | string;
    /**
     * 名称
     */
    endTime?: null | string;
    /**
     * 图片名称
     */
    fileName?: null | string;
    /**
     * 加盟商编号
     */
    franchiseeCode?: null | string;
    id?: null | string;
    /**
     * md5
     */
    md5?: null | string;
    /**
     * 签约模式
     */
    mode?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 联系电话
     */
    phone?: null | string;
    /**
     * 加盟商编号
     */
    startTime?: null | string;
    /**
     * 合同状态 有效, 已过期,已终止
     */
    status?: null | string;
    /**
     * 名称
     */
    terms?: null | string;
    /**
     * 链路id
     */
    traceId?: null | string;
    /**
     * 最后更新时间
     */
    updateTime?: null | string;
    /**
     * 最后修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}

/**
 * 参数
 *
 * FollowUpInsertOrUpdateParams
 */
export interface IFollowInsertRequest {
    /**
     * code
     */
    code?: null | string;
    /**
     * 反馈意见
     */
    feedback?: null | string;
    /**
     * 跟进内容
     */
    followUpContent?: null | string;
    /**
     * 跟进方式
     */
    followUpMethod?: null | string;
    /**
     * 加盟商编号
     */
    franchiseeCode?: null | string;
    id?: null | string;
    /**
     * 意向程度
     */
    intentionLevel?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 合同状态 有效, 已过期,已终止
     */
    status?: null | string;
    [property: string]: any;
}

/**
 * FollowUpOneResult
 */
export interface IFollowInsertResponse {
    /**
     * code
     */
    code?: null | string;
    /**
     * name
     */
    name?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标记 `0 正常 1 已删除`
     */
    deleteFlag?: number | null;
    /**
     * 反馈意见
     */
    feedback?: null | string;
    /**
     * 跟进内容
     */
    followUpContent?: null | string;
    /**
     * 跟进方式
     */
    followUpMethod?: null | string;
    /**
     * 加盟商编号
     */
    franchiseeCode?: null | string;
    /**
     * id
     */
    id?: null | string;
    /**
     * 意向程度
     */
    intentionLevel?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 合同状态 有效, 已过期,已终止
     */
    status?: null | string;
    traceId?: null | string;
    /**
     * 修改时间
     */
    updateTime?: null | string;
    /**
     * 修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}

/**
 * 加盟商跟进表
 *
 * FollowUp
 */
export interface IFollowUpOne {
    /**
     * code
     */
    code?: null | string;
    /**
     * 创建时间
     */
    createTime?: null | string;
    /**
     * 创建人
     */
    createUser?: null | string;
    /**
     * 删除标记 `0 正常 1 已删除`
     */
    deleteFlag?: number | null;
    /**
     * 反馈意见
     */
    feedback?: null | string;
    /**
     * 跟进内容
     */
    followUpContent?: null | string;
    /**
     * 跟进方式
     */
    followUpMethod?: null | string;
    /**
     * 加盟商编号
     */
    franchiseeCode?: null | string;
    /**
     * id
     */
    id?: null | string;
    /**
     * 意向程度
     */
    intentionLevel?: null | string;
    /**
     * 顺位
     */
    orderNum?: number | null;
    /**
     * 合同状态 有效, 已过期,已终止
     */
    status?: null | string;
    traceId?: null | string;
    /**
     * 修改时间
     */
    updateTime?: null | string;
    /**
     * 修改人
     */
    updateUser?: null | string;
    [property: string]: any;
}


class IntentionService {
    async page(searchVo: IMaintenanceArchivesSearch) {
        const apiUrl = '/yh-franchisee/franchisee/list'
        return await httpRequest.post<IPage<FranchiseePageResult>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    async insert(insertVo: IFranchiseePageResultInsert) {
        const apiUrl = '/yh-franchisee/franchisee/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    async update(updateVo: IFranchiseePageResultUpdate) {
        const apiUrl = '/yh-franchisee/franchisee/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    async one(id: string) {
        const apiUrl = `/yh-franchisee/franchisee/one/${id}`
        return await httpRequest.get<FranchiseePageResult>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async cooperationagreementInsert(updateVo: ICooperationAgreementInsertOrUpdateParams) {
        const apiUrl = '/yh-franchisee/cooperationagreement/insert'
        return await httpRequest.post<boolean>(apiUrl, updateVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    //新增跟进记录
    async followInsert(updateVo: IFollowInsertRequest) {
        const apiUrl = '/yh-franchisee/follow/insert'
        return await httpRequest.post<IFollowInsertResponse>(apiUrl, updateVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }


    async followOne(franchiseeCode: string) {
        const apiUrl = `/yh-franchisee/follow/one/${franchiseeCode}`
        return await httpRequest.get<IFollowUpOne[]>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }


    async finish(updateVo: IFollowInsertRequest) {
        const apiUrl = `/yh-franchisee/franchisee/finish`
        return await httpRequest.post<IFollowInsertResponse>(apiUrl, updateVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async vehicleLicense(file: any) {
        const apiUrl = `/yh-franchisee/baidu_api/vehicle_license`
        return await httpRequest.post<any>(apiUrl, file, {
            baseURL: getBaseCiRequestUrl(), token: getToken(), headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async fmsSupplyAccountInit(params: any) {
        const apiUrl = `/fms/account/summary/customer/customerAccount`
        return await httpRequest.post<any>(apiUrl, params, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

}

export const intentionService = new IntentionService()
